export default __webpack_public_path__ + "static/media/logo.30860dae.png";